import { apiClient } from "./apiClient";

/** Marketplace app listesi */
export async function getApps(accessToken) {
  const res = await apiClient.get("/marketplace/apps", {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

/** Marketplace.js ile uyumluluk (alias) */
export const getMarketplaceApps = getApps;

/** Tek app detayı */
export async function getApp(accessToken, appId) {
  const res = await apiClient.get(`/marketplace/apps/${appId}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

/** Kurulum job'u oluştur */
export async function createInstallation(accessToken, payload) {
  const res = await apiClient.post("/marketplace/installations", payload, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

/** Yeni marketplace app ekler (superadmin only) */
export async function createApp(accessToken, payload) {
  const res = await apiClient.post("/marketplace/apps", payload, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

/** Marketplace app günceller - docker_image, name vb. (superadmin only) */
export async function updateApp(accessToken, appId, payload) {
  const res = await apiClient.patch(`/marketplace/apps/${appId}`, payload, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return res.data;
}

/** Kurulum geçmişi */
export async function getInstallations(accessToken, { edge_id, status } = {}) {
  const params = {};
  if (edge_id) params.edge_id = edge_id;
  if (status) params.status = status;
  const res = await apiClient.get("/marketplace/installations", {
    headers: { Authorization: `Bearer ${accessToken}` },
    params,
  });
  return res.data;
}

/** Kurulu app'i kaldır (uninstall_pending yapar, Edge poll ile kaldırır) */
export async function uninstallInstallation(accessToken, installationId) {
  const res = await apiClient.post(
    `/marketplace/installations/${installationId}/uninstall`,
    {},
    { headers: { Authorization: `Bearer ${accessToken}` } }
  );
  return res.data;
}

/** Başarısız kurulumu tekrar dene */
export async function retryInstallation(accessToken, installationId) {
  const res = await apiClient.post(
    `/marketplace/installations/${installationId}/retry`,
    {},
    { headers: { Authorization: `Bearer ${accessToken}` } }
  );
  return res.data;
}

/** App güncellemesini kurulu olduğu tüm edge'lere yayar (superadmin). marketplace_app.docker_image kullanılır. */
export async function rolloutUpdate(accessToken, appId) {
  const res = await apiClient.post(
    `/marketplace/apps/${appId}/rollout-update`,
    {},
    { headers: { Authorization: `Bearer ${accessToken}` } }
  );
  return res.data;
}
